"use client";

import { fontWeights } from "@/utils/fonts";
import AllIconsComponent from "../custom-icons/AllIconsComponent";

interface ServiceCardProps {
  title: string;
  description: string;
  icon: string;
  iconWidth?: string;
  iconHeight?: string;
}

export function ServiceCard({ title, description, icon: Icon, iconWidth, iconHeight }: ServiceCardProps) {
  return (
    <div
      className="
    relative
    border
    border-[#002F6D] 
    rounded-[10px]
    p-4
    pt-6
    lg:p-8
    lg:pt-10
    flex
    flex-col 
    items-center 
    text-center 
    transition-all 
    hover:shadow-lg
    bg-white 
    h-auto
    max-w-[600px]
    xl:w-[560px]
    "
    >
      {/* <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-white px-3">
        <AllIconsComponent iconName={Icon} width={"60px"} height={"60px"} color="#002F6D" />
      </div> */}
      <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-white px-3">
        <div className="iconResponsive flex items-center justify-center">
          <AllIconsComponent
            iconName={Icon}
            width="100%"
            height="100%"
            color="#002F6D"
          />
        </div>
      </div>
      <h3
        className="
      text-[17px]
      md:text-[18px] 
      lg:text-[20px] 
      xl:text-[24px]  
      font-medium 
      text-[#002F6D]
      mb-[10px]
      md:mb-4
      lg:mb-[18px]
      "
        style={{ fontFamily: "Lato", fontWeight: fontWeights.lato.semiBold }}
      >
        {title}
      </h3>
      <p
        className="
      text-[14px] 
      lg:text-[17px] 
      2xl:text-[18px] 
      text-black
      leading-5
      "
        style={{ fontFamily: "Asap", fontWeight: fontWeights.asap.regular }}
      >
        {description}
      </p>
    </div>
  );
}
